import * as yup from "yup";

export const worklogMissingSchemas = yup
  .object({
    leave_type: yup.string().required("Leave Type is required"),
    reason: yup
      .string()
  })
  .required();